module.exports = __webpack_public_path__ + "img/look.d7bb0aef.png";